import React from 'react';

class FormatoSimplificado1347545PlanGamerPlus_pdf extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
        document.title = 'Red Itmex - Documentacion - Formato Simplificado 1347545 Plan Gamer +';
        this.abrirPdf()
    }
    abrirPdf = () => {
        window.location.href = 'https://firebasestorage.googleapis.com/v0/b/reditmextrescero.appspot.com/o/datasheets%2Flegal%2FITMEX_FORMATO_SIMPLIFICADO_1347545_GAMER%2B_2024_V2.pdf?alt=media&token=d9f31a0a-917c-44ac-8300-9beeceecad3b';
    }
    render() {
        return (
            <div>Loading...</div>
        )
    }
}
export default FormatoSimplificado1347545PlanGamerPlus_pdf